import { Inject, Injectable, Injector }from '@angular/core';

import { Utilities_DatasourceService } from './Utilities.datasource.index';
import { Addresses_DatasourceService } from './Addresses.datasource.index';
import { Carriers_DatasourceService } from './Carriers.datasource.index';
import { PurchaseOrders_DatasourceService } from './PurchaseOrders.datasource.index';
import { SalesOrders_DatasourceService } from './SalesOrders.datasource.index';
import { Notifications_DatasourceService } from './Notifications.datasource.index';
import { Materials_DatasourceService } from './Materials.datasource.index';
import { Invoices_DatasourceService } from './Invoices.datasource.index';
import { Inventory_DatasourceService } from './Inventory.datasource.index';
import { FootprintApiManager_DatasourceService } from './FootprintApiManager.datasource.index';
import { Reports_DatasourceService } from './Reports.datasource.index';

import { app_custom_ds_placard_ordersService } from './app.datasource.index';

@Injectable({ providedIn: 'root' })
export class app_DatasourceService {

  constructor(
    private injector: Injector
  ) {
    this.Utilities = this.injector.get(Utilities_DatasourceService);
    this.Addresses = this.injector.get(Addresses_DatasourceService);
    this.Carriers = this.injector.get(Carriers_DatasourceService);
    this.PurchaseOrders = this.injector.get(PurchaseOrders_DatasourceService);
    this.SalesOrders = this.injector.get(SalesOrders_DatasourceService);
    this.Notifications = this.injector.get(Notifications_DatasourceService);
    this.Materials = this.injector.get(Materials_DatasourceService);
    this.Invoices = this.injector.get(Invoices_DatasourceService);
    this.Inventory = this.injector.get(Inventory_DatasourceService);
    this.FootprintApiManager = this.injector.get(FootprintApiManager_DatasourceService);
    this.Reports = this.injector.get(Reports_DatasourceService);
  }

    public Utilities: Utilities_DatasourceService;
    public Addresses: Addresses_DatasourceService;
    public Carriers: Carriers_DatasourceService;
    public PurchaseOrders: PurchaseOrders_DatasourceService;
    public SalesOrders: SalesOrders_DatasourceService;
    public Notifications: Notifications_DatasourceService;
    public Materials: Materials_DatasourceService;
    public Invoices: Invoices_DatasourceService;
    public Inventory: Inventory_DatasourceService;
    public FootprintApiManager: FootprintApiManager_DatasourceService;
    public Reports: Reports_DatasourceService;
  public app: app_DatasourceService = this;

  // injecting lazily in order to avoid circular dependencies
  private _custom_ds_placard_orders: app_custom_ds_placard_ordersService;
  public get custom_ds_placard_orders(): app_custom_ds_placard_ordersService {
    if(!this._custom_ds_placard_orders) {
      this._custom_ds_placard_orders = this.injector.get(app_custom_ds_placard_ordersService);
    }
    return this._custom_ds_placard_orders;
  }
}

